module.exports = __webpack_public_path__ + "static/media/custom_publishing_1_B.0385886b.png";